
import { Popover, InfiniteScroll } from "element-ui"
import dayjs from "dayjs"
import { getLoginStatus, redirectToLoginPage } from "@/utils/utils"
import { getUserNotificationHasUnread, getUserNotificationMsgList } from "@/api/notification"
import notificationDetail from "@/components/drawer/notificationDetail.vue"
import notificationItem from "@/components/notificationCenter/notificationItem.vue"
import notificationEmpty from "@/components/notificationCenter/notificationEmpty.vue"

const MAX_CLIENT_WIDTH = 1360

export default {
  name: "NotificationPanel",
  components: {
    [Popover.name]: Popover,
    notificationDetail,
    notificationItem,
    notificationEmpty
  },
  directives: {
    InfiniteScroll
  },
  data() {
    return {
      visible: false,
      isOnline: false,
      hasUnread: false,
      popoverOffset: 0,
      list: [],
      page: 1,
      pageSize: 10,
      loading: false,
      hasMore: true,
      detailVisible: false,
      msgId: "",
      ignoreOutsideClick: false
    }
  },

  mounted() {
    const { isOnline } = getLoginStatus()
    this.isOnline = isOnline

    if (this.isOnline) {
      this.getUnreadFlag()
    }

    this.$bus.$on("getUnreadFlag", this.getUnreadFlag)
    document.body.addEventListener("click", this.handleClickOutside)
  },
  beforeDestroy() {
    this.$bus.$off("getUnreadFlag")
    document.body.removeEventListener("click", this.handleClickOutside)
  },
  methods: {
    async getUnreadFlag() {
      const { data } = await getUserNotificationHasUnread()
      this.hasUnread = data
    },
    handleGoNotification() {
      if (!this.isOnline) {
        if (window.location.pathname.includes("/auth/login")) {
          window.location.reload()
        } else {
          const notificationPath = `${this.MAIN_ORIGIN}${this.MAIN_PATH}/notification_center`
          redirectToLoginPage(notificationPath)
        }
      } else {
        this.calcOffset()
        this.visible = !this.visible

        if (this.visible) {
          this.list = []
          this.page = 1
          this.hasMore = true
          this.getList()
        }
      }
    },
    loadMore() {
      if (this.loading || !this.hasMore) return
      this.page++
      this.getList()
    },
    async getList() {
      try {
        this.loading = true
        const params = {
          currentPage: this.page,
          pageSize: this.pageSize
        }
        const { data } = await getUserNotificationMsgList({ param: JSON.stringify(params) })
        const newData = data?.result || []
        if (data?.totalCount == 0) {
          this.hasMore = false
        } else {
          this.list.push(...newData)
          if (data?.lastPage) {
            this.hasMore = false
          }
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    learnMore(item) {
      if (!item.jumpUrl) {
        this.detailVisible = true
        this.ignoreOutsideClick = true
        this.msgId = item.msgId
      } else {
        this.visible = false
        window.location.href = `${this.MAIN_ORIGIN}${item.jumpUrl}`
      }
    },
    viewAll() {
      this.visible = false
      this.$navigation.push({
        path: "/notification_center"
      })
    },
    closeDrawer() {
      this.detailVisible = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.ignoreOutsideClick = false
        }, 100)
      })
    },
    calcOffset() {
      const deviceWidth =
        document.documentElement.clientWidth >= MAX_CLIENT_WIDTH
          ? MAX_CLIENT_WIDTH
          : document.documentElement.clientWidth
      const scale = parseFloat(deviceWidth / MAX_CLIENT_WIDTH)
      // 0.58rem => bell距离父级最右边的距离
      this.popoverOffset = scale * 100 * 0.58
    },
    handleClickOutside(event) {
      if (this.ignoreOutsideClick) return

      if (!this.visible) return

      const popoverEl = this.$refs.popoverRef?.popperElm
      const triggerEl = this.$refs.triggerBtn

      const isInside = popoverEl?.contains(event.target) || triggerEl?.contains(event.target)

      if (!isInside) {
        this.visible = false
      }
    },
    handleClose() {
      this.visible = false
    }
  }
}
